/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Cancellation_HintInputs */

const en_admin_resource_form_cancellation_hint = /** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A booking may be canceled up until this many hours before it starts`)
};

const de_admin_resource_form_cancellation_hint = /** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenze wie viele Stunden vor Beginn einer Buchung diese storniert werden kann`)
};

const es_admin_resource_form_cancellation_hint = /** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limita el número de horas antes de que se pueda cancelar una reserva`)
};

const fr_admin_resource_form_cancellation_hint = /** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitez le nombre d'heures avant le début d'une réservation que l'on peut annuler.`)
};

const nl_admin_resource_form_cancellation_hint = /** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een reservering mag tot dit aantal uur vóór de start worden geannuleerd`)
};

/** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */
const it_admin_resource_form_cancellation_hint = en_admin_resource_form_cancellation_hint;

/** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_cancellation_hint = en_admin_resource_form_cancellation_hint;

/** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */
const pl_admin_resource_form_cancellation_hint = en_admin_resource_form_cancellation_hint;

/** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */
const hu_admin_resource_form_cancellation_hint = en_admin_resource_form_cancellation_hint;

/** @type {(inputs: Admin_Resource_Form_Cancellation_HintInputs) => LocalizedString} */
const ro_admin_resource_form_cancellation_hint = en_admin_resource_form_cancellation_hint;

/**
* | output |
* | --- |
* | "A booking may be canceled up until this many hours before it starts" |
*
* @param {Admin_Resource_Form_Cancellation_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_cancellation_hint = /** @type {((inputs?: Admin_Resource_Form_Cancellation_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Cancellation_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_cancellation_hint(inputs)
	if (locale === "de") return de_admin_resource_form_cancellation_hint(inputs)
	if (locale === "es") return es_admin_resource_form_cancellation_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_cancellation_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_cancellation_hint(inputs)
	if (locale === "it") return it_admin_resource_form_cancellation_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_cancellation_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_cancellation_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_cancellation_hint(inputs)
	return ro_admin_resource_form_cancellation_hint(inputs)
});
export { admin_resource_form_cancellation_hint as "admin.resource_form.cancellation_hint" }